<main [@routeAnimations]="getRouteAnimationData()">
  <router-outlet></router-outlet>
</main>
